<script>
    import moment from 'moment';
    export default {
        // props: ['assignment', 'user'],
        data() {
            return {
                started: '',
                timer: 0,
                timeAllowed: 30
            }
        },
        computed: {
            // lastProblem: function() {
            //     return this.assignment.problems.slice(-1)[0];
            // },
            // date: function() {
            //     return moment.utc(this.assignment.date).format('MMM DD, YYYY'); 
            // }
            // timer: function() {
            //     return setInterval(() => this)
            // }
            timeLeft: function () {
                return this.timeAllowed - this.timer;
            }
        },
        watch: {
            timeLeft: function(val) {
                if (val == 0) {
                    this.submitTest();
                }
            }
        },
        mounted() {
            this.startTimer();
        },
        methods: {
            startTest() {
                this.started = 1;
                this.timer = 0;
            },
            submitTest() {
                if(this.started != 1) return false;
                this.$refs.test.submit();
            },
            startTimer() {
                setInterval(() => (this.timer += 1), 60*1000);
            }
            // complete() {
            //     axios.patch('/assignments/'+this.assignment.id+'/complete')
            //         .then(({data}) => {
            //             this.next();
            //         });
            // }
        }
    }
</script>